export default __webpack_public_path__ + "static/media/visszajelzés.92bc74a2.png";